export default __webpack_public_path__ + "static/media/IUB_Transcript.4e6c57d9.pdf";